import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-add-company',
  templateUrl: './admin-add-company.component.html',
  styleUrls: ['./admin-add-company.component.css']
})
export class AdminAddCompanyComponent implements OnInit {

  errMessage = "";
  successMessage = "";
  routeID: string = this.route.snapshot.params.id;
  authToken = localStorage.getItem('auth');
  company = [];
  users = [];
  form: FormGroup;
  main_user_form: FormGroup;
  messageErr;
  texts = 'Lisää yritys'
  isLoading = false;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) {

     }


     ngOnInit(): void {
      if(this.routeID){
        this.getBusinessDetails();
        this.texts = 'Muokkaa yritystä'
      }
      else{
        //set public leaver automatically to false

      }

    
      

      this.form = this.fb.group({
        businessName: ['', [
          Validators.required,
        ]],
        email: ['', [
          Validators.required,
        ]],
        phone: ['', [
          Validators.required,
        ]],
        rootID: ['', [
          Validators.required,
        ]],
        vatID: ['', [
          Validators.required,
        ]],
        public_leaver: [''],
        main_email: ['', [
          this.routeID ? Validators.required : Validators.nullValidator,
        ]],
        main_firstName: ['', [
         this.routeID ? Validators.required : Validators.nullValidator,
        ]],
        main_lastName: ['', [
         this.routeID ? Validators.required : Validators.nullValidator,
        ]],
  
        ovt:'',
        operator: '',

      }); 


    }

    get email() { return this.form.get('email') };
    get businessName() { return this.form.get('businessName') };
    get phone() { return this.form.get('phone') };
    get rootID() { return this.form.get('rootID') };
    get public_leaver() { return this.form.get('public_leaver') };
    get vatID() { return this.form.get('vatID') };
    get operator() { return this.form.get('operator') };
    get ovt() { return this.form.get('ovt') };

    get main_email() { return this.form.get('main_email') };
    get main_phone() { return this.form.get('main_phone') };
    get main_firstName() { return this.form.get('main_firstName') };
    get main_lastName() { return this.form.get('main_lastName') };

    getBusinessDetails() {

      this.http.get(environment.ADMIN_BUSINESS_DETAILS + '/' +this.routeID, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            this.company = res.message[0];

            var cm = this.company;
            console.log(cm)

            this.form = this.fb.group({
              businessName: [cm['businessName'], Validators.required],
             email: [cm['email'], Validators.required],
             phone: [cm['phone'], Validators.required],
             businessEmail: [cm['email'], Validators.required],
             businessPhone: [cm['phone'], Validators.required],
             operator: [cm['operator'], Validators.required],
            ovt: [cm['einvoiceaddress'], Validators.required],
             vatID: [cm['vatID'], Validators.required],
             public_leaver: [cm['public_leaver'], Validators.required],
           });
  
  
            console.log(this.company);
  
          }
          else {
            var anElm = document.getElementById('notadded');
            anElm.style.display="block";
            console.log('ei ole kyseistä käyttäjää')
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })
    }

    onSubmit() {
      if(this.routeID){
        this.updateCompany();
      }
      else{
        this.addCompany();
      }
    }

    addCompany() {
      this.isLoading = true;

      var pub_leaver = this.form.value.public_leaver;
      if(pub_leaver == 'true' || pub_leaver == true) {
        pub_leaver = true;
      }
      else {
        pub_leaver = false;
      }

      //Check if businessID contains special characters
      var regex = /^[a-zA-Z0-9]*$/;
      if(!regex.test(this.form.value.rootID)){
        alert('Yrityksen ID ei saa sisältää erikoismerkkejä');
        this.isLoading = false;
        return;
      }
      //Check if contains spaces
      if(this.form.value.rootID.indexOf(' ') >= 0){
        alert('Yrityksen ID ei saa sisältää välilyöntejä');
        this.isLoading = false;
        return;
      }

      //check if businessID is empty
      if(this.form.value.rootID == ''){
        alert('Yrityksen ID ei saa olla tyhjä');
        this.isLoading = false;
        return;
      }

      var req = {
        businessName: this.form.value.businessName,
        email: this.form.value.email,
        phone: this.form.value.phone,
        ovt: this.form.value.ovt,
        operator: this.form.value.operator,
        businessID: this.form.value.rootID,
        public_leaver: pub_leaver,
        vatID: this.form.value.vatID,
        user: {
          email: this.form.value.main_email,
          firstName: this.form.value.main_firstName,
          lastName: this.form.value.main_lastName,
        }
      }


      this.http.post(environment.ADMIN_BUSINESS, req, this.httpOptions).subscribe(
        (res: any) => {
          this.isLoading = false;
          if(res.status == 200 ) {
            this.router.navigate(['/admins/admin/companies/company/company-details/'+req.businessID]);
            console.log('Successfully added a business');
  
          }
          else {
            alert(res.message);
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })
    }

    updateCompany() {

      var pub_leaver = this.form.value.public_leaver;
      if(pub_leaver == 'true' || pub_leaver == true) {
        pub_leaver = true;
      }
      else {
        pub_leaver = false;
      }


      var req = {
        businessName: this.form.value.businessName,
        email: this.form.value.email,
        phone: this.form.value.phone,
        einvoiceaddress: this.form.value.ovt,
        operator: this.form.value.operator,
        businessEmail: this.form.value.businessEmail,
        businessPhone: this.form.value.businessPhone,
        public_leaver: pub_leaver,
        businessID: this.routeID,
        vatID: this.form.value.vatID,
        description_video_url: this.company['description_video_url'],
        description: this.company['description'],
      }


      this.http.put(environment.ADMIN_BUSINESS, req, this.httpOptions).subscribe(
        (res: any) => {
          this.isLoading = false;
          if(res.status == 200 ) {
            this.router.navigate(['/admins/admin/companies/company/company-details/'+req.businessID]);
            console.log('Successfully edited business');
  
          }
          else {
            alert(res.message);
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })

      console.log(req)

    }


}
